/**
 * UTM Parameter types and constants
 */

export interface UtmParameters {
  utm_source: string | null
  utm_medium: string | null
  utm_campaign: string | null
  utm_term: string | null
  utm_content: string | null
  transaction_id: string | null // from hasoffers
}

export interface UtmData {
  parameters: UtmParameters
  timestamp: number
  source: 'url' | 'sessionStorage' | 'localStorage' | 'cookie' | 'indexeddb'
}

export interface StorageOptions {
  sessionStorage?: boolean
  localStorage?: boolean
  indexedDB?: boolean
  cookies?: boolean
  expireDays?: number
}

export const UTM_PARAMETER_KEYS: (keyof UtmParameters)[] = [
  'utm_source',
  'utm_medium',
  'utm_campaign',
  'utm_term',
  'utm_content',
  'transaction_id',
]

export const UTM_STORAGE_KEYS = {
  UTM_DATA: 'btm_utm_data',
  UTM_TIMESTAMP: 'btm_utm_timestamp',
  UTM_ANONYMOUS_ID: 'btm_utm_anonymous_id',
} as const

export const UTM_COOKIE_PREFIX = 'btm_utm_'
export const UTM_DB_NAME = 'BreaktimeUtmDB'
export const UTM_DB_VERSION = 1
export const UTM_STORE_NAME = 'utmData'
export const DEFAULT_COOKIE_EXPIRY_DAYS = 30

export interface IndexedDBUtmRecord {
  parameters: UtmParameters
  timestamp: number
  lastUpdated: number
}
